module.exports = __webpack_public_path__ + "static/img/account.91de6c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/account.png
// module id = zX4s
// module chunks = 2